/**
 * Created by B032151 on 10/26/2016.
 */
import _ from 'underscore';
import Constants from '../constants/constants';
import { dispatcher } from '../dispatcher/dispatcher';
import { storeUtils } from './util';
const { ActionTypes } = Constants;
var _events = new storeUtils.EventEmitter();
var CHANGE_EVENT = 'change';
var STATUS = Constants.RestrictionStatuses;
import { ServerActions } from '../actions/serverActions';
var ServerApi = require('../actions/serverAPI');
import { subdivisionStore } from '../stores/subdivision';
import { runCompareStore } from '../stores/runCompareStore';
import {formValidation} from '../util/formValidation';

var _compareList = [];
var _compareListLoading = false;
var _restrictionLoading = false;
var _guidListLoading = false;
var _form;
var _currentCompareGuids = [];
var _newCompareGuids = [];
var _compareGuidListItems = [];
var _compareItemDetailsOpened = false;
var _compareItemListOpened = true;
var _resetSub = false;
var _messageSuccess = "";

function convertServerGuidToCompareGuid(guids) {
    return guids.map(function (g) {
        var obj = {};
        obj["id"] = g.tmdsUid;
        obj["beginMp"] = g.beginMp;
        obj["endMp"] = g.endMp;
        obj["mpSuffix"] = formValidation.stringIsNullOrEmpty(g.mpSuffix) ? "" : g.mpSuffix;
        obj["trackName"] = g.trackName;
        obj["dbVersion"] = g.databaseVersion;
        obj["ptcVersion"] = g.versionPtcReference;
        obj["subdivision"] = g.subdivisionName;

        return obj;
    })
}

function convertSchematicGuidToCompareGuid(guids) {
    return guids.map(function (g) {
        var obj = {};
        obj["id"] = g.attributes.tmdsUid;
        obj["beginMp"] = g.attributes.beginMp;
        obj["endMp"] = g.attributes.endMp;
        obj["mpSuffix"] = formValidation.stringIsNullOrEmpty(g.attributes.mpSuffix) ? "" : g.attributes.mpSuffix;
        obj["trackName"] = g.attributes.trackName;
        obj["dbVersion"] = g.attributes.databaseVersion;
        obj["ptcVersion"] = g.attributes.versionPtcReference;
        obj["subdivision"] = g.attributes.subdivisionName;

        return obj;
    })
}

function createCompareGuidListItem(currentGuid, newGuid, compareCode) {
    var guidListItem = {};
    guidListItem["leftGuid"] = currentGuid;
    guidListItem["rightGuid"] = newGuid;
    guidListItem["compareCode"] = compareCode;

    if (guidListItem.compareCode == "M") {
        guidListItem["changeList"] = [];
        //Check each of the properties to see what changed
        if (guidListItem.leftGuid.beginMp != guidListItem.rightGuid.beginMp) {
            guidListItem.changeList.push("beginMp");
        }

        if (guidListItem.leftGuid.endMp != guidListItem.rightGuid.endMp) {
            guidListItem.changeList.push("endMp");
        }

        if (guidListItem.leftGuid.mpSuffix != guidListItem.rightGuid.mpSuffix) {
            guidListItem.changeList.push("mpSuffix");
        }

        if (guidListItem.leftGuid.trackName != guidListItem.rightGuid.trackName) {
            guidListItem.changeList.push("trackName");
        }
    }

    return guidListItem;
}

var dispatchToken = dispatcher.register(function (action) {

    //this action comes from the dispatcher
    switch (action.type) {
        case ActionTypes.COMPARE_SUBDIVISION_CHANGED:
        case ActionTypes.COMPARE_GIS_ENVIRONMENT_CHANGED:
            dispatcher.waitFor([subdivisionStore.dispatchToken]);
            var historyParams = { subdivision: subdivisionStore.getSelectedSub(), status: [STATUS.ISSUED, STATUS.REQUESTED] };
            ServerActions.getRequestListForCompare(historyParams);

            _events.trigger(CHANGE_EVENT);
            break;

        case ActionTypes.TOGGLE_COMPARE_LISTS:
            _compareItemDetailsOpened = !_compareItemDetailsOpened;
            _compareItemListOpened = !_compareItemListOpened;
            _events.trigger(CHANGE_EVENT);
            break;

        case ActionTypes.OPENING_RESTRICTION:
            _restrictionLoading = true;
            _events.trigger(CHANGE_EVENT);
            break;

        case ActionTypes.SERVER_ACTION_FAILED:
            _restrictionLoading = false;
            _events.trigger(CHANGE_EVENT);
            break;

        case ActionTypes.HISTORY_LIST_LOADING:
            _compareListLoading = true;
            _events.trigger(CHANGE_EVENT);
            break;

        case ActionTypes.HISTORY_LIST_LOADED:
            dispatcher.waitFor([runCompareStore.dispatchToken]);
            _compareListLoading = false;
            action.data.forEach(function (item) {
                item.colorCode = "Gray";
            });
            var comparedItems = runCompareStore.getComparedItems();
            _compareList = action.data;

            //If we have compare file from server update items color and sort
            if (comparedItems) {
                _compareList.forEach(function (item) {
                    var colorResult = _.findWhere(comparedItems, { syncId: item.syncId });

                    if (colorResult)
                        item.colorCode = colorResult.color;
                });

                var order = ["Gray", "Red", "Yellow", "Green"];
                _compareList = _.sortBy(_compareList, function (item) {
                    return _.indexOf(order, item.colorCode);
                });
            }
            _events.trigger(CHANGE_EVENT);
            break;

        case ActionTypes.RESET_COMPARE_DETAILS:
            _compareGuidListItems = [];
            _form = null;
            _compareItemDetailsOpened = false;
            _compareItemListOpened = true;
            _events.trigger(CHANGE_EVENT);
            break;

        // case ActionTypes.OPEN_FORM_A_RESTRICTION:
        //     //Check that the form was loaded correctly before trying to open it
        //     if (action.form) {
        //         _form = action.form;
        //         //_currentCompareGuids = action.form.trackGuids;
        //         _currentCompareGuids = convertServerGuidToCompareGuid(action.form.trackGuids);
        //         console.log(ActionTypes.OPEN_FORM_A_RESTRICTION, _form);
        //         _restrictionLoading = false;
        //         _events.trigger(CHANGE_EVENT);
        //     }
        //     break;
        //
        // case ActionTypes.OPEN_FORM_A_REQUEST:
        //     //Check that the form was loaded correctly before trying to open it
        //     if (action.form) {
        //         _form = action.form;
        //         //_currentCompareGuids = action.form.trackGuids;
        //         _currentCompareGuids = convertServerGuidToCompareGuid(action.form.trackGuids);
        //         console.log(ActionTypes.OPEN_FORM_A_REQUEST, _form);
        //         _restrictionLoading = false;
        //         _events.trigger(CHANGE_EVENT);
        //     }
        //     break;
        //
        // case ActionTypes.OPEN_FORM_B_RESTRICTION:
        //     //Check that the form was loaded correctly before trying to open it
        //     if (action.form) {
        //         _form = action.form;
        //         //_currentCompareGuids = action.form.trackGuids;
        //         _currentCompareGuids = convertServerGuidToCompareGuid(action.form.trackGuids);
        //         console.log(ActionTypes.OPEN_FORM_B_RESTRICTION, _form);
        //         _restrictionLoading = false;
        //         _events.trigger(CHANGE_EVENT);
        //     }
        //     break;
        //
        // case ActionTypes.OPEN_FORM_B_REQUEST:
        //     //Check that the form was loaded correctly before trying to open it
        //     if (action.form) {
        //         _form = action.form;
        //         //_currentCompareGuids = action.form.trackGuids;
        //         _currentCompareGuids = convertServerGuidToCompareGuid(action.form.trackGuids);
        //         console.log(ActionTypes.OPEN_FORM_B_REQUEST, _form);
        //         _restrictionLoading = false;
        //         _events.trigger(CHANGE_EVENT);
        //     }
        //     break;

        // case ActionTypes.SCHEMATIC_CALCULATED_GUIDS:
        //     _newCompareGuids = convertSchematicGuidToCompareGuid(action.guids);
        //     var compareGuidListItems = [];
        //     var addedCount = 0;
        //     var removedCount = 0;
        //     var modifiedCount = 0;
        //     var sameCount = 0;
        //
        //     var intersection = _.filter(_currentCompareGuids, function (obj) { return _.findWhere(_newCompareGuids, { beginMp: obj.beginMp, endMp: obj.endMp, mpSuffix: obj.mpSuffix, subdivision: obj.subdivision, id: obj.id, trackName: obj.trackName }); });
        //
        //     intersection.forEach(
        //         function (guid) {
        //             compareGuidListItems.push(createCompareGuidListItem(guid, guid, " ")); //All of these guids are the same so create the compare items as such
        //             sameCount++;
        //         }
        //     );
        //
        //     if (_newCompareGuids.length != intersection.length) {
        //         console.log("Different");
        //         var leftOnlyGuids = _.filter(_currentCompareGuids, function (obj) { return !_.findWhere(_newCompareGuids, { beginMp: obj.beginMp, endMp: obj.endMp, mpSuffix: obj.mpSuffix, subdivision: obj.subdivision, id: obj.id, trackName: obj.trackName }); });
        //         var rightOnlyGuids = _.filter(_newCompareGuids, function (obj) { return !_.findWhere(_currentCompareGuids, { beginMp: obj.beginMp, endMp: obj.endMp, mpSuffix: obj.mpSuffix, subdivision: obj.subdivision, id: obj.id, trackName: obj.trackName }); });
        //
        //         //Check each guid in the left list against guids in the right list. If its id is not in the right list, it is removed.
        //         // if its id is in the right list, it is a modify
        //         leftOnlyGuids.forEach(
        //             function (leftGuid) {
        //                 var rightGuid = _.find(rightOnlyGuids, function (obj) { return obj.id == leftGuid.id });
        //
        //                 if (rightGuid == undefined) {
        //                     //This is a removed guid
        //                     compareGuidListItems.push(createCompareGuidListItem(leftGuid, rightGuid, "R"));
        //                     removedCount++;
        //                 }
        //                 else {
        //                     //This is a modified Guid. Do some comparison stuff to find what fields changed. Remove the guid from right list
        //                     compareGuidListItems.push(createCompareGuidListItem(leftGuid, rightGuid, "M"));
        //                     modifiedCount++;
        //                     rightOnlyGuids = _.reject(rightOnlyGuids, function (obj) { return obj.id == leftGuid.id }); //Remove the guid from the right list
        //                 }
        //             }
        //         );
        //
        //         //This array now only holds guids with ids not in the left list. So mark them as adds
        //         rightOnlyGuids.forEach(
        //             function (addedGuid) {
        //                 compareGuidListItems.push(createCompareGuidListItem(null, addedGuid, "A"));
        //                 addedCount++;
        //             }
        //         );
        //     }
        //
        //     _compareGuidListItems = compareGuidListItems.sort(
        //         function (a, b) {
        //             if (a.leftGuid != null) {
        //                 if (b.leftGuid != null)
        //                     return a.leftGuid.beginMp - b.leftGuid.beginMp;
        //                 else
        //                     return a.leftGuid.beginMp - b.rightGuid.beginMp;
        //             }
        //             else {
        //                 if (b.leftGuid != null)
        //                     return a.rightGuid.beginMp - b.leftGuid.beginMp;
        //                 else
        //                     return a.rightGuid.beginMp - b.rightGuid.beginMp;
        //             }
        //         }
        //     );
        //
        //     //Final Step is to toggle the compare page to the guid list
        //     _compareItemDetailsOpened = true;
        //     _compareItemListOpened = false;
        //
        //     console.log(addedCount + " Added, " + removedCount + " Removed, " + modifiedCount + " Modified, " + sameCount + " Unchanged.");
        //     _events.trigger(CHANGE_EVENT);
        //     break;

        case ActionTypes.SUBDIVISION_RECALCULATE_SUCCESS:
            _resetSub = true
            _messageSuccess = "The recalculate is successful"
            _events.trigger(CHANGE_EVENT);
            break;

        case ActionTypes.SUBDIVISION_RECALCULATE_FAILED:
            _messageSuccess = "Failed to recalculate, please try again momentarily"
            _events.trigger(CHANGE_EVENT);
            break;

        case ActionTypes.RUNCOMPARE_CALCULATED_GUIDS:
            var results = action.results
            var subdivisionSelected = action.selectedSub
            var selectedSchematic = action.selectedSchematic
            var _saveArray = []

            if (_compareList.length == results.length) {
                _compareList.forEach(function (item) {

                    var colorResult = _.findWhere(results, { syncId: item.syncId });

                    if (colorResult) {
                        item.colorCode = colorResult.colorCode;
                        _saveArray.push({ "syncId": item.syncId, "subdivision": subdivisionSelected, "color": item.colorCode, "schematicType": selectedSchematic })
                    }
                });

                var order = ["Red", "Yellow", "Green"];
                _compareList = _.sortBy(_compareList, function (item) {
                    return _.indexOf(order, item.colorCode);
                });

                var schematicType = action.schematicType
                results.forEach(function (item) {
                    item.schematicType = schematicType;
                });
                ServerApi.saveCompareResult(_saveArray);

                setTimeout(function () {
                    dispatcher.dispatch({
                        type: ActionTypes.COMPARE_ITEMS_SAVED,
                    });
                }, 1);
            }

            _events.trigger(CHANGE_EVENT);
            break;

        case ActionTypes.SORT_RESULTS:
            dispatcher.waitFor([runCompareStore.dispatchToken]);
            var results = runCompareStore.getRunCompareResults();
            var order = _.pluck(results, "syncId");
            _compareList = _.sortBy(_compareList, function (items) {
                return _.indexOf(order, items.syncId);
            });
            _events.trigger(CHANGE_EVENT);
            break;

        default:


        //no op
    }
});//end of dispatch token

export const compareDetailsStore = {
    subscribe: _events.on,
    unsubscribe: _events.off,
    dispatchToken,
    compareListLoading: function () {
        return _compareListLoading;
    },
    getCompareList: function () {
        return _compareList;
    },
    restrictionLoading: function () {
        return _restrictionLoading
    },
    getCompareGuids: function () {
        return _compareGuidListItems
    },
    guidListLoading: function () {
        return _guidListLoading
    },
    getDetailsOpened: function () { return _compareItemDetailsOpened },
    getListOpened: function () { return _compareItemListOpened },
    getForm: function () { return _form; },
    getReset: function () { return _resetSub; },
    getMessageSuccess: function () { return _messageSuccess; }
};
